import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Session, SessionsService } from '../../services/sessions.service';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { InputGroupModule } from 'primeng/inputgroup';
import { FluidModule } from 'primeng/fluid';
import { MenuItem } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { SessionSignInFlag } from '../session-signin/session-signin.component';

@Component({
  selector: 'app-besharp-session-selector',
  imports: [
    ButtonModule,
    CardModule,
    DividerModule,
    SplitButtonModule,
    FluidModule,
    MenuModule,
    InputGroupModule,
    StyleClassModule,
  ],
  templateUrl: './session-selector.component.html',
  styleUrl: './session-selector.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SessionSelectorComponent implements OnInit {
  protected sessionsService = inject(SessionsService);
  protected router: Router = inject(Router);

  public constructor() {}

  protected dropDownMenuContent: Map<string, MenuItem[]> = new Map<string, MenuItem[]>();

  protected sessions: Session[] = [];
  protected activeSession: string | null = null;

  loadSessionsOrGoToSignIn() {
    const sessions = this.sessionsService.getSessions();

    //If there are no sessions to select, go to sign-in
    if (sessions.length === 0) {
      this.router.navigate(['session', 'signin'], { queryParams: { flags: SessionSignInFlag.SessionRequired } });
    }

    return sessions;
  }

  async ngOnInit() {
    this.sessions = this.loadSessionsOrGoToSignIn();

    const newMenuContent = new Map<string, MenuItem[]>();
    for (const session of this.sessions) {
      newMenuContent.set(session.id, [
        {
          label: 'Sign out',
          command: (_) => {
            this.sessionsService.removeSession(session.id);
            this.sessions = this.loadSessionsOrGoToSignIn();
          },
          icon: 'pi pi-sign-out',
        },
      ]);
    }

    this.dropDownMenuContent = newMenuContent;
    this.sessions.sort((a, b) => (a.isExpired() ? 0 : 1) - (b.isExpired() ? 0 : 1));
    this.activeSession = this.sessionsService.activeSessionId;
  }

  protected async onSessionSelect(id: string) {
    await this.sessionsService.setActiveSession(id);
  }

  protected getCurrentTimestamp(): number {
    return new Date().getTime();
  }
}
